import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {HttpClient} from '@angular/common/http';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {ContentScope, PlatformCommand} from '@shared/commands/command-base';
import {take, takeUntil} from 'rxjs/operators';
import {Api} from '@shared/constants/common-field.constants';
import {GridValueChangeEvent} from '@shared/models/common.models';
import {Configuration} from '@shared/models/configuration';
import {DialogModel} from '@shared/models/dialog.model';
import {UserModel} from '@shared/models/user.model';
import {getUserInfo} from '@shared/store/selectors/security.selector';
import {Store} from '@ngrx/store';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {CreateChatConversationCommand} from '@features/task-manager/collaboration/store/collaboration.command';
import {CreateChatConversationAction} from '@features/task-manager/collaboration/store/collaboration.action';
import {ConversationComponentName} from '@features/task-manager/collaboration/store/collaboration.constants';
import {CollaborationState} from '@features/task-manager/collaboration/store/collaboration.reducer';

@Injectable({
  providedIn: 'root',
})
export class PlatformToolCreateConsultantHandler implements IPlatformToolHandler {
  magicLinkModel: MagicLinkModel;
  ngUnsubscribe = new Subject<void>();
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  invalidateSubject: InvalidateSubject;
  currentUser: UserModel;
  constructor(private httpClient: HttpClient,
              private commandService: CommandService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              public collaborationStore: Store<CollaborationState>,
              private snackBarService: SnackBarService,
              private securityStore: Store<SecurityState>
  ) {
    this.securityStore.select(getUserInfo).pipe(takeUntil(this.ngUnsubscribe)).subscribe(currentUser => {
      if (currentUser) {
        this.currentUser = currentUser;
      }
    });
    this.invalidateSubject = new InvalidateSubject();
  }
  executeCommand(command: PlatformCommand) {
    switch (command.name) {
      case 'CreateConsultantCommand':
        this.CreateConsultant();
        return;
    }
    this.executeCommandApi(command);
  }

  private executeCommandApi(command: PlatformCommand) {
    console.log('[Executing PlatformCommand] -> ', command.name);
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(res => {
          console.log('Command Response', res);
          this.fuseSplashScreenService.hide();
          if (res.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(res.fieldValues['RedirectUrl']);
            return;
          }
          if (res.fieldValues['RedirectCommand']) {
            this.executeCommand(res.fieldValues['RedirectCommand']);
            return;
          }
          if (res.fieldValues['SnackBarMessage']) {
            const duration = res.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(res.fieldValues['SnackBarMessage'], duration);
          }
          this.invalidateSubject.invalidate();
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
  }
  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private handleActions($event: GridValueChangeEvent) {
    switch ($event.action.id) {
      case 'Edit':
        this.openEditor($event);
        break;
      case 'Archive':
        this.archiveCase($event);
        break;
      case 'OpenConversation':
        this.openConversation($event);
        break;
      default:
        if (this.magicLinkModel.additionalCommands[$event.action.id]) {
          const command = this.magicLinkModel.additionalCommands[$event.action.id];
          command.fieldValues['ItemId'] = $event.item.id;
          this.executeCommand(command);
        }
        break;
    }
  }

  private openEditor(event: any) {
    const minWidth = '800px';
    const maxWidth = '800px';

    const sourceKey = this.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, sourceKey).subscribe(state => {
      if (state.action === 'OK') {
        const command = new PlatformCommand('UpdateWorkspaceCommand', Api.AdminPanel);
        command.fieldValues['Id'] = event.item.id;
        command.fieldValues[event.fieldDefinition.key] = event.item.cells[event.fieldDefinition.key].value;
        this.executeCommand(command);
      }
    });
  }

  valueChanged($event: GridValueChangeEvent) {
    console.log('[Event]', $event);
    if ($event.action) {
      this.handleActions($event);
      return;
    }
    if (this.handleByFieldDefinition($event)) {
      return;
    }
  }
  private handleByFieldDefinition($event: GridValueChangeEvent): boolean {
    if ($event.fieldDefinition && $event.fieldSection.headerKey === 'ExpertServiceConsultant') {
      switch ($event.fieldDefinition.key) {
        case 'Services':
          this.openServicesEditor($event);
          return true;
        default:
          return false;
      }
    }
    return false;
  }

  private CreateConsultant() {
    const dialogModel = DialogModel.create('Create Consultant', 'CreateConsultantDialogComponent',
      {},
      '800px',
      '800px');
    this.dialogService.showOkCancelDialog(dialogModel)
      .pipe(take(1))
      .subscribe(state => {
        console.log(state);
        if (state.action === 'OK') {
          this.fuseSplashScreenService.show();
          const createConsultantCommand = new PlatformCommand('CreateConsultantCommand', 'MarketPlaceApi');
          createConsultantCommand.fieldValues['ServiceIds'] = state.data.input.expertServicesModels;
          createConsultantCommand.fieldValues['Contacts'] = state.data.input.contacts;
          this.commandService.executePlatformCommand(createConsultantCommand).pipe(take(1)).subscribe(commandResponse => {
            console.log('create consultant Command Response', commandResponse);
            this.fuseSplashScreenService.hide();
            if (commandResponse.fieldValues['SnackBarMessage']) {
              const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
              this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
            }
            if (commandResponse.fieldValues['Error']) {
              this.snackBarService.showError(commandResponse.fieldValues['Error']);
            }
            this.invalidateSubject.invalidate();
          });
        }
      });

  }

  private archiveCase(event: any) {
    const dialogModel = DialogModel.create('Archive Consultant',
      'ConsultantArchiveDialogComponent',
      {},
      '600px', '700px',
      false);
    dialogModel.okCaption = 'Archive';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
      if (res.action === 'OK') {
        const archiveConsultantCommand = new PlatformCommand('ArchiveCaseCommand', Api.MarketPlace);
          archiveConsultantCommand.fieldValues['ConsultantId'] = event.item.id;
        if (res.data.input['comment'] && res.data.input['comment'].length > 0) {
          archiveConsultantCommand.fieldValues['ArchivedComment'] = res.data.input['comment'];
        }
        this.commandService.executePlatformCommand(archiveConsultantCommand).pipe(take(1)).subscribe(commandResponse => {
          console.log('create consultant Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (commandResponse.fieldValues['Error']) {
            this.snackBarService.showError(commandResponse.fieldValues['Error']);
          }
          this.invalidateSubject.invalidate();
        });
      }
    });
  }

  private openServicesEditor(event: GridValueChangeEvent) {
    console.log('Services Editor');
    const dialogModel: DialogModel = DialogModel.create(
      'Update Services',
      'ExpertServiceCheckboxUpdateDialogComponent', {
        selectedItems: event.item.cells.Services.value,
        sourceType: 'UpdateConsultantServices'
      },
      '400px',
      '400px',
      false
    );
    dialogModel.okCaption = 'Done';
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        const updateConsultantCommand = new PlatformCommand('UpdateConsultantCommand', Api.MarketPlace);
        updateConsultantCommand.fieldValues['Email'] = event.item.cells.Email.value;
        updateConsultantCommand.fieldValues['ServiceIds'] = res.data.input.serviceIds;
        this.commandService.executePlatformCommand(updateConsultantCommand).pipe(take(1)).subscribe(commandResponse => {
          console.log('create consultant Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (commandResponse.fieldValues['Error']) {
            this.snackBarService.showError(commandResponse.fieldValues['Error']);
          }
          this.invalidateSubject.invalidate();
        });
      }
    });
  }


  private openConversation($event: GridValueChangeEvent) {
      const rolesArray = [];
      const otherUser = this.getOpenConversationOtherUser($event);
      rolesArray.push({'user': this.currentUser, permissionType: 290, 'roleTypes': [1, 2, 3]});
      rolesArray.push({'user': otherUser, permissionType: 290, 'roleTypes': [1, 2, 3]});
      const createChatConversationCommand = new CreateChatConversationCommand(
        '[COMPANY_ID]-chat',
        this.getOneToOneChatTitle(otherUser),
        false
        , 0,
        'Conversation',
        rolesArray,
        false,
        null,
        null
      );
      createChatConversationCommand.scope = ContentScope.Company;
      this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
    }

  private getOpenConversationOtherUser(event: any) {
      return {
        firstName: event.item.cells['FirstName'].value,
        lastName: event.item.cells['LastName'].value,
        email: event.item.cells['Email'].value
      };
    }

    getOneToOneChatTitle(otherUser) {
      if (otherUser) {
        return `${otherUser.firstName} ${otherUser.lastName}`;
      }
      return '';
    }
}
